import {InventoryListPage as InventoryListPageNewTheme} from '@/features/InventoryList/InventoryListPage'
import {selectIsNewDesignCountry} from '@/store/slices/countryCodeSlice'
import {useSelector} from 'react-redux'
import {Fulfillment} from './Fulfillment'

/**
 * Select Fulfillment editor shell.
 * Selects legacy or new themed list by country.
 * @returns {JSX.Element}
 */
export const FulfillmentEditor = () => {
  const isNewDesignCountry = useSelector(selectIsNewDesignCountry)

  return isNewDesignCountry ? <InventoryListPageNewTheme /> : <Fulfillment />
}
